import { useQuery } from '@tanstack/react-query';
import { listMessages } from '@/api/messages';
import { queryKeys } from '@/lib/queryKeys';

export function useMessagesQuery(conversationId?: string) {
  return useQuery({
    queryKey: queryKeys.conversations.messages(conversationId || ''),
    queryFn: () => listMessages(conversationId as string),
    enabled: Boolean(conversationId),
  });
}
